import { createElement as rc } from 'react';
import styled from '../styled';
import webOnlyStyles from '../webOnlyStyles';

import fromTheme from '../fromTheme';
import View from './View';
import Text from './Text';
import Button from './Button';

const _Chip = styled(View)`
    background-color: ${fromTheme('backgroundHint')};
    margin: 3px;
    padding: 0 8px;
    border-radius: ${fromTheme('button', 'fontSize')};
    align-items: center;
`;
const ChipText = styled(Text)`
    color: ${fromTheme('labelColor')};
    font-size: ${fromTheme('button', 'fontSize')};
`;
let ChipButton = styled(Button).attrs({ name: 'chip', title: 'Remove', buttonStyle: 'CircleAdd', icon: 'close', size: 'xs' })`
    background-color: ${fromTheme('backgroundHint')};
    margin-right: 0;
`;

ChipButton = webOnlyStyles(ChipButton)`
    &:hover {
        background-color: ${fromTheme('button', 'grayHighlight')};
        margin-right: 0 !important;
    }
`;

const ChipContainer = styled(View)`
    align-items: flex-start;
    flex-wrap: wrap;
`;

function Chip(props) {
    const { id, value, onClick } = props;
    return rc(_Chip, null, rc(ChipText, {}, value), rc(ChipButton, { onClick, 'data-testid': `cmd${id}` }));
}

Chip.Container = ChipContainer;

export default Chip;
